import BaseApi from './BaseApi';
import { ApiPaths } from './ApiPaths';

/**
 * API for setting and retrieving products data
 */
const create = () => {  // this will change for prod deployment
    // Create and configure an apisauce-based api object.
    const api = BaseApi.create();
    
    const savePOMSelection = (payload) => api.post(ApiPaths.PRODUCT, payload);
    const getEligibleAddOnProducts = (action) => api.get(ApiPaths.GET_PRODUCT_ADDONS(action.caseId));

    // Return back a collection of functions
    return {
        savePOMSelection, getEligibleAddOnProducts
    }
}

// let's return back our create method as the default.
export default {
    create
}